// extracted by mini-css-extract-plugin
module.exports = {"event_main_container":"Event_event_main_container__3Keid","event_text":"Event_event_text__23r62","text_center":"Event_text_center__1dyuk"};